import type { IconSvgObject } from './types';

const ArrowRight02Icon: IconSvgObject = [
  ["path", { d: "M13 17.9995L19 11.9995L13 5.99951M18.5 11.9995L5 11.9995", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default ArrowRight02Icon;
